import axiosInstance from "@/api/axios-instance";
import { Region } from "../types/region";

export async function getRegion(id: string): Promise<Region> {
  const response = await axiosInstance.get(`/region/${id}`);
  return response.data as Region;
}
